import chill1 from "../images/chill1.jpeg";
import chill2 from "../images/chill2.jpeg";
import chill3 from "../images/chill3.jpeg";
import chill4 from "../images/chill4.jpeg";
import chill5 from "../images/chill5.jpeg";
import chill6 from "../images/chill6.jpeg";
import chill7 from "../images/chill7.jpeg";
const chillArray = () => {
  return [chill1, chill2, chill3, chill4, chill5, chill6, chill7];
};

export default chillArray();
